import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import { httpProtocol, hostname, port } from 'utils/hostHelper'
//use bundled lib

import { init, switchMode as _switchMode, getMode, importGraphic, removeGraphic, removeAllGraphic, getGraphicsManager, switchGraphic, switchMouseIcon } from '../../utils/bundle.draw'; // lib/bundle.draw.js

import { v1 } from 'uuid';
var IMPORT_TEMPLATE = {
  direction: '{"type":"direction","vertex":[{"x":1047,"y":451.5},{"x":1053,"y":925.5}]}',
  line: '{"type":"line","vertex":[{"x":858,"y":58.5},{"x":54,"y":187.5}]}',
  rectangle: '{"type":"rectangle","vertex":[{"x":900,"y":52.5},{"x":1059,"y":208.5}]}',
  polygon: '{"type":"polygon","vertex":[{"x":1551,"y":994.5},{"x":1596,"y":520.5},{"x":1617,"y":121.5},{"x":1797,"y":151.5},{"x":1758,"y":601.5},{"x":1713,"y":928.5},{"x":1695,"y":1078.5},{"x":1578,"y":1069.5}]}',
  polyline: "{\"type\":\"polyline\",\"vertex\":[{\"x\":651,\"y\":1048.5},{\"x\":879,\"y\":307.5},{\"x\":1122,\"y\":292.5},{\"x\":1236,\"y\":526.5},{\"x\":1527,\"y\":1030.5}]}",
  polyline_pair: "{\"type\":\"polyline_pair\",\"vertex\":[{\"x\":651,\"y\":1048.5},{\"x\":651,\"y\":307.5}],\"vertex2\":[{\"x\":1051,\"y\":1048.5},{\"x\":1051,\"y\":307.5}], \"names\": [\"From\", \"To\", \"1\"]}"
};
var MOUSE_ICON = {
  erase: "erase",
  draw: "draw",
  drag: "drag",
  dragging: "dragging",
  drawDot: "drawDot"
};
var drawingToolApp;

var DrawingToolView = /*#__PURE__*/function (_Component) {
  _inherits(DrawingToolView, _Component);

  var _super = _createSuper(DrawingToolView);

  function DrawingToolView() {
    var _this;

    _classCallCheck(this, DrawingToolView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      inputValue: IMPORT_TEMPLATE.rectangle,
      imgWidth: 0,
      imgHeight: 0,
      isLoaded: false
    });

    _defineProperty(_assertThisInitialized(_this), "drawingTool", void 0);

    _defineProperty(_assertThisInitialized(_this), "initDrawingTool", function (config) {
      var width = config.width;
      var height = config.height;
      var onReady = config.onReady;

      _this.initResolution(_this.props.url, width, height); //console.log("kz drawingTool mount", this.props)


      _this.drawingTool = init({
        target: _this.props.id,
        bgImgUrl: _this.props.url,
        onEditStart: _this.handleOnEditStart,
        onEditEnd: _this.handleOnEditEnd,
        onSelectGraphic: _this.onSelectGraphic,
        width: width,
        height: height,
        onReady: onReady
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnEditStart", function (graphic, status) {
      console.log('kz handleOnEditStart', graphic, status);

      if (_this.props.onEditStart) {
        _this.props.onEditStart();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnEditEnd", function (graphic, status) {
      var _this$state = _this.state,
          imgWidth = _this$state.imgWidth,
          imgHeight = _this$state.imgHeight;

      var _graphicToGeoObj = graphicToGeoObj(graphic, imgWidth, imgHeight, _this.props.supportPercentage),
          oindex = _graphicToGeoObj.oindex,
          graphId = _graphicToGeoObj.graphId,
          value = _graphicToGeoObj.value;

      console.log("kz handleOnEditEnd", graphic, status, "\nformat:", graphId, value, "\noindex:", oindex);
      drawingToolApp.handleOnEditEnd(graphic);

      if (_this.props.onEditEnd) {
        _this.props.onEditEnd();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addGraphic", function (json, _id) {
      try {
        addGraphic(json, _id);
      } catch (error) {
        console.error('addGraphic fail', error);
      }
    });

    return _this;
  }

  _createClass(DrawingToolView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      drawingToolApp.setSupportPercentage(this.props.supportPercentage);
      var config = {
        width: this.props.width,
        height: this.props.height,
        onReady: function onReady() {
          drawingToolApp.onReady();

          if (_this2.props.onReady) {
            _this2.props.onReady();
          }

          _this2.setState({
            isLoaded: true
          });
        }
      };
      this.initDrawingTool(config);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (this.props.width === nextProps.width && this.props.height === nextProps.height || !this.state.isLoaded) {
        return;
      }

      if (this.drawingTool) {
        this.drawingTool.destroy(true);
      }

      var config = {
        width: nextProps.width,
        height: nextProps.height,
        onReady: function onReady() {
          drawingToolApp.onReady();

          if (nextProps.onReady) {
            nextProps.onReady();
          }

          _this3.setState({
            isLoaded: true
          });
        }
      };
      this.initDrawingTool(config); //@Todo do not redraw by props change

      return;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.drawingTool) {
        this.drawingTool.destroy(true);
      }
    }
  }, {
    key: "initResolution",
    value: function () {
      var _initResolution = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, defaultWidth, defaultHeight) {
        var img, _width, _height;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getMeta(url);

              case 2:
                img = _context.sent;
                // console.log('hl img: ', img)
                _width = defaultWidth;
                _height = defaultHeight;

                if (img) {
                  _width = img.width;
                  _height = img.height;
                }

                drawingToolApp.setResolution(_width, _height);
                this.setState({
                  imgWidth: _width,
                  imgHeight: _height
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initResolution(_x2, _x3, _x4) {
        return _initResolution.apply(this, arguments);
      }

      return initResolution;
    }()
  }, {
    key: "onSelectGraphic",
    value: function onSelectGraphic(g) {
      drawingToolApp.selectGraphic(g);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "App",
        id: "drawingToolApp"
      }, /*#__PURE__*/React.createElement("div", {
        id: this.props.id
      }));
    }
  }]);

  return DrawingToolView;
}(Component);

DrawingToolView.propTypes = {
  id: PropTypes.string,
  key: PropTypes.string,
  url: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  supportPercentage: PropTypes.bool,
  onEditStart: PropTypes.func,
  onEditEnd: PropTypes.func,
  onReady: PropTypes.func
};
var TARGET_TYPE = {
  // "@root":"@root",
  // "@geoGroup":"@geoGroup",
  display: "display",
  direction: "direction",
  line: "line",
  rectangle: "rectangle",
  roi: "roi",
  polyline: "polyline",
  polyline_pair: "polyline_pair"
};
var DT_STATUS = {
  init: "init",
  erase: "erase",
  edit: "edit",
  drag: "drag",
  draw: "draw"
};

var DrawingToolApp = /*#__PURE__*/function () {
  function DrawingToolApp() {
    var _this4 = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        onSelectGraphic = _ref.onSelectGraphic,
        setGeometry = _ref.setGeometry,
        onReady = _ref.onReady;

    _classCallCheck(this, DrawingToolApp);

    _defineProperty(this, "onReady", function () {
      _this4._onReady();
    });

    this._onSelectGraphic = onSelectGraphic || function () {};

    this._setGeometry = setGeometry || function () {};

    this._onReady = onReady || function () {};

    this.currentGeoItem = undefined;
    this.status = DT_STATUS.init;
    this.targetType = "init";
    this.geoObjects = [];
    this.SUPPORT_TARGET_TYPES = Object.keys(TARGET_TYPE);
    this.STATUS = Object.keys(DT_STATUS);
    this.width = 0;
    this.height = 0, this.supportPercentage = false;
  }

  _createClass(DrawingToolApp, [{
    key: "setResolution",
    value: function setResolution(width, height) {
      this.width = width;
      this.height = height;
    }
  }, {
    key: "setSupportPercentage",
    value: function setSupportPercentage(supportPercentage) {
      this.supportPercentage = supportPercentage;
    }
  }, {
    key: "setCallback",
    value: function setCallback() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          onSelectGraphic = _ref2.onSelectGraphic,
          setGeometry = _ref2.setGeometry,
          onReady = _ref2.onReady;

      this._onSelectGraphic = onSelectGraphic || this._onSelectGraphic;
      this._setGeometry = setGeometry || this._setGeometry;
      this._onReady = onReady || this._onReady;
    }
  }, {
    key: "selectGraphic",
    value: function selectGraphic() {
      if (this.status == DT_STATUS.erase) {
        // handle delete
        var g = arguments.length <= 0 ? undefined : arguments[0]; //becareful the gid

        this.deleteGraphic(g.id);
      } else {
        this._onSelectGraphic.apply(this, arguments);
      }
    }
  }, {
    key: "deleteGraphic",
    value: function deleteGraphic(graphId) {
      var r = graphId.match(/(.*)_oindex_([0-9]+)$/);
      var gid = graphId;
      var oindex = undefined;

      if (r == null) {
        gid = graphId;
      } else {
        gid = r[1];
        oindex = r[2];
      }

      var oindexflag = [];
      this.geoObjects.map(function (geo) {
        var r = geo.graphId.match(/(.*)_oindex_([0-9]+)$/);
        var _gid = geo.graphId;
        var _oindex = undefined;

        if (r != null) {
          _gid = r[1];
          _oindex = r[2];
        }

        if (_gid == gid && _oindex) {
          oindexflag[_oindex] = true;
        }
      });
      var bias = 0;

      if (oindex) {
        for (var i = oindex - 1; i >= 0; i--) {
          if (!oindexflag[i]) {
            bias++;
          }
        }
      }

      this._setGeometry(gid, oindex - bias, null); // setGeometry = (gid, oindex, value) => {


      removeGraphic(graphId);
      console.log("kz this.geoObjects", this.geoObjects, "\ncurrent oindexflag:", oindexflag);
      this.geoObjects = this.geoObjects.filter(function (g) {
        return g.graphId !== graphId;
      });
    } //@Todo make outside no need to know oindex

  }, {
    key: "setGeometry",
    value: function setGeometry(_ref3) {
      var graphic = _ref3.graphic,
          geoObj = _ref3.geoObj,
          oindex = _ref3.oindex;
      var id = this.getGeoObjId();

      if (graphic) {
        var _graphicToGeoObj2 = graphicToGeoObj(graphic, this.width, this.height, this.supportPercentage),
            oi = _graphicToGeoObj2.oindex,
            value = _graphicToGeoObj2.value;

        this._setGeometry(id, oi, value);
      } else {
        this._setGeometry(id, oindex, geoObj);
      }
    }
  }, {
    key: "handleOnEditEnd",
    value: function handleOnEditEnd(graphic) {
      this.setGeometry({
        graphic: graphic
      });

      if (this.targetType === TARGET_TYPE.roi) {
        if (getMode() == 'polygon') {
          this.createNewRoiPolygon();
        }
      }
    }
  }, {
    key: "changeTarget",
    value: function () {
      var _changeTarget = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var targetInfo,
            geoObjects,
            url,
            targetType,
            cid,
            sid,
            gcid,
            gid,
            arrow,
            startPointColor,
            modeMap,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                targetInfo = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                geoObjects = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : [];
                url = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
                targetType = targetInfo.type, cid = targetInfo.cid, sid = targetInfo.sid, gcid = targetInfo.gcid, gid = targetInfo.gid, arrow = targetInfo.arrow, startPointColor = targetInfo.startPointColor;
                this.geoObjects = geoObjects.map(function (g) {
                  // @Todo? roi's graph id should implement inside
                  if (g.$type === 'roi') {
                    var GRAPHIC_OPACITY = 0.6;
                    return createPolygonObjectsFromRoi(g, GRAPHIC_OPACITY).map(function (p) {
                      p.graphId = p.id;
                      return p;
                    });
                  }

                  return _objectSpread(_objectSpread({}, g), {}, {
                    graphId: g.id
                  });
                }).flat(); // flat polygon array from roi

                this.targetType = targetType;
                this.geoInfo = {
                  cid: cid,
                  sid: sid,
                  gcid: gcid,
                  gid: gid,
                  arrow: arrow,
                  startPointColor: startPointColor
                };

                if (window.isDev) {
                  console.log('sj change target', geoObjects);
                }

                reDraw(this.geoObjects, this.width, this.height);
                switchMouseIcon(MOUSE_ICON.draw);
                this.status = DT_STATUS.init;
                modeMap = {
                  // "@root":"read",
                  // "@geoGroup":"read",
                  display: "read",
                  direction: "direction",
                  line: "line",
                  rectangle: "rectangle",
                  roi: "polygon",
                  polyline: "polyline",
                  polyline_pair: "polyline_pair"
                };

                if (targetType == "display") {
                  this.switchMode(modeMap[targetType]);
                } else if (targetType == "roi") {
                  this.createNewRoiPolygon();
                } // else if(targetType == 'polyline_pair') {
                // }
                else {
                  this.status = DT_STATUS.draw;

                  if (geoObjects.length > 0) {
                    switchGraphic(this.getGeoObjId());
                  } else if (targetType !== "polyline_pair") {
                    // polyline_pair do not init one
                    this.createNewGraphic(modeMap[targetType], this.getGeoObjId());
                  }
                } //todo draw after change target


              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function changeTarget() {
        return _changeTarget.apply(this, arguments);
      }

      return changeTarget;
    }()
  }, {
    key: "getGeoObjId",
    value: function getGeoObjId() {
      // may not equal to current graphic id. ex: roi's {xxx_oindex_xx} id
      // @Todo? create a map for internal graph id mapping to geo objects id
      return _.get(this.geoInfo, "gid");
    }
  }, {
    key: "switchMode",
    value: function switchMode(mode, graphId) {
      this.mode = mode;

      _switchMode(mode, graphId);
    }
  }, {
    key: "clickErase",
    value: function clickErase() {
      this.status = DT_STATUS.erase;
      this.switchMode("dragging");
      switchMouseIcon(MOUSE_ICON.erase);
    }
  }, {
    key: "clickDrag",
    value: function clickDrag() {
      this.status = DT_STATUS.drag;
      this.switchMode("dragging");
      switchMouseIcon(MOUSE_ICON.drag);
    }
  }, {
    key: "clickEdit",
    value: function clickEdit() {
      this.status = DT_STATUS.edit; // only support target: polyline_pair

      var id = this.getGeoObjId();
      this.switchMode("edit", id);
      switchMouseIcon(MOUSE_ICON.drawDot);
    }
  }, {
    key: "clickDraw",
    value: function clickDraw() {
      this.status = DT_STATUS.draw;
      switchMouseIcon(MOUSE_ICON.draw);
      var id = this.getGeoObjId();
      var objNum = this.geoObjects.length;

      if (this.targetType == TARGET_TYPE.polyline_pair) {
        var serialNo = _.get(this.geoObjects, "[0].$.serial_no");

        if (0 != objNum) {
          this.deleteGraphic(id);
        }

        var o = this.createNewGraphic(TARGET_TYPE.polyline_pair, id, {
          names: ["From", "To", serialNo]
        });
        this.setGeometry({
          geoObj: o
        });
      } else if (this.targetType == TARGET_TYPE.roi) {
        var _this$createNewRoiPol = this.createNewRoiPolygon(),
            _o = _this$createNewRoiPol.geoObj,
            oindex = _this$createNewRoiPol.oindex; // this.setGeometry(o)


        this.setGeometry({
          geoObj: _o,
          oindex: oindex
        });
      } else {
        if (0 != objNum) {
          //this.switchMode(this.targetType, id)
          switchGraphic(id);
        } else {
          this.createNewGraphic(this.targetType, id);
        }
      }
    }
  }, {
    key: "createNewGraphic",
    value: function createNewGraphic(graphType, graphId) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var o = _objectSpread({}, option);

      if (this.geoInfo.arrow) {
        o.arrow = true;
      }

      if (this.geoInfo.startPointColor) {
        o.startPointColor = this.geoInfo.startPointColor;
      }

      var _initNewGraph = initNewGraph(graphType, graphId, o, this.supportPercentage),
          geoObj = _initNewGraph.geoObj;

      this.geoObjects.push(geoObj);
      return geoObj;
    }
  }, {
    key: "createNewRoiPolygon",
    value: function createNewRoiPolygon() {
      var id = this.getGeoObjId();
      var objNum = this.geoObjects.length;
      var graphId = "".concat(id, "_oindex_", 0);
      var oindex = 0;

      if (0 < objNum) {
        graphId = "".concat(id, "_oindex_").concat(objNum);
        oindex = objNum;
      }

      var o = this.createNewGraphic("polygon", graphId);
      return {
        graphId: graphId,
        id: id,
        oindex: oindex,
        geoObj: o
      };
    }
  }]);

  return DrawingToolApp;
}();

drawingToolApp = new DrawingToolApp();

function graphicToGeoObj(graphic, width, height, supportPercentage) {
  var oindex = undefined;
  var value = {};
  var id = graphic.id;
  var _vertexs = {},
      _vertexs2 = {};

  if (graphic.id.includes("oindex")) {
    var r = graphic.id.match(/(.*)_oindex_([0-9]+)$/);

    if (r) {
      oindex = r[2]; // becareful `r[1]` may not be gid since when display mode id may look like

      /*
      id: "area_0_oindex_0"
      id: "area_0_oindex_1"
      id: "area2_1_oindex_0"
      id: "area_2_oindex_0"
      id: "area_2_oindex_1"
      id: "area_3_oindex_0"
      id: "area_3_oindex_1"
      id: "area_3_oindex_2"
       in order to tell same gid from different condition
       */
      // id = r[1];
    } // console.log("kz id/oindex", id,oindex)


    if (supportPercentage) {
      _vertexs = {
        point_percentage: graphic.savedvertexs.map(function (vertex) {
          return {
            x: [(vertex.x * 100 / width).toFixed(5)],
            y: [(vertex.y * 100 / height).toFixed(5)]
          };
        })
      };
    } else {
      _vertexs = {
        point: graphic.savedvertexs.map(function (vertex) {
          return {
            x: [vertex.x],
            y: [vertex.y]
          };
        })
      };
    }

    value = {
      polygon_list: [{
        polygon: [{
          point_list: [// {
          //     point: graphic.savedvertexs.map(
          //         vertex => {
          //             return {
          //                 x: [vertex.x],
          //                 y: [vertex.y],
          //             };
          //         }
          //     ),
          //     point_percentage: graphic.savedvertexs.map(
          //         vertex => {
          //             return {
          //                 x: [(vertex.x * 100 / width).toFixed(5)],
          //                 y: [(vertex.y * 100 / height).toFixed(5)],
          //             };
          //         }
          //     ),
          // },
          _vertexs]
        }]
      }]
    };
  } else if (graphic.type == "polyline_pair") {
    if (supportPercentage) {
      _vertexs = {
        point_percentage: graphic.savedvertexs.map(function (vertex) {
          return {
            x: [(vertex.x * 100 / width).toFixed(5)],
            y: [(vertex.y * 100 / height).toFixed(5)]
          };
        })
      };
      _vertexs2 = {
        point_percentage: graphic.savedvertexs2.map(function (vertex) {
          return {
            x: [(vertex.x * 100 / width).toFixed(5)],
            y: [(vertex.y * 100 / height).toFixed(5)]
          };
        })
      };
    } else {
      _vertexs = {
        point: graphic.savedvertexs.map(function (vertex) {
          return {
            x: [vertex.x],
            y: [vertex.y]
          };
        })
      };
      _vertexs2 = {
        point: graphic.savedvertexs2.map(function (vertex) {
          return {
            x: [vertex.x],
            y: [vertex.y]
          };
        })
      };
    }

    value = {
      polyline: [{
        point_list: [// {
        //     point: graphic.savedvertexs.map(vertex => {
        //         return { x: [vertex.x], y: [vertex.y] };
        //     }),
        //     point_percentage: graphic.savedvertexs.map(vertex => {
        //         return { 
        //             x: [(vertex.x * 100 / width).toFixed(5)], 
        //             y: [(vertex.y * 100 / height).toFixed(5)] 
        //         };
        //     }),
        // },
        _vertexs]
      }, {
        point_list: [// {
        //     point: graphic.savedvertexs2.map(vertex => {
        //         return { x: [vertex.x], y: [vertex.y] };
        //     }),
        //     point_percentage: graphic.savedvertexs2.map(vertex => {
        //         return { 
        //             x: [(vertex.x * 100 / width).toFixed(5)], 
        //             y: [(vertex.y * 100 / height).toFixed(5)] 
        //         };
        //     }),
        // },
        _vertexs2]
      }]
    };
  } else {
    if (supportPercentage) {
      _vertexs = {
        point_percentage: graphic.savedvertexs.map(function (vertex) {
          return {
            x: [(vertex.x * 100 / width).toFixed(5)],
            y: [(vertex.y * 100 / height).toFixed(5)]
          };
        })
      };
    } else {
      _vertexs = {
        point: graphic.savedvertexs.map(function (vertex) {
          return {
            x: [vertex.x],
            y: [vertex.y]
          };
        })
      };
    }

    value = {
      point_list: [// {
      //     point: graphic.savedvertexs.map(vertex => {
      //         return { x: [vertex.x], y: [vertex.y] };
      //     }),
      //     point_percentage: graphic.savedvertexs.map(vertex => {
      //         return { 
      //             x: [(vertex.x * 100 / width).toFixed(5)], 
      //             y: [(vertex.y * 100 / height).toFixed(5)] 
      //         };
      //     }),
      // },
      _vertexs]
    };
  }

  return {
    graphId: id,
    value: value,
    oindex: oindex
  };
}

function initNewGraph(graphType, newGraphId) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var width = arguments.length > 3 ? arguments[3] : undefined;
  var height = arguments.length > 4 ? arguments[4] : undefined;
  var supportPercentage = arguments.length > 5 ? arguments[5] : undefined;

  if (Object.keys(IMPORT_TEMPLATE).indexOf(graphType) == -1) {
    throw new Error('not support graph type:' + graphType);
  }

  var defaults = {
    color: undefined,
    //COLORS_REF[colorIndex],
    opacity: 1,
    names: []
  };

  var o = _objectSpread(_objectSpread({}, defaults), option);

  var id = _switchMode(graphType, newGraphId, o);

  var g = getGraphicsManager().get(id);

  var _graphicToGeoObj3 = graphicToGeoObj(g, width, height, supportPercentage),
      value = _graphicToGeoObj3.value; // return { ...value, graphId: id}


  return {
    geoObj: _objectSpread(_objectSpread({}, value), {}, {
      graphId: id
    }),
    graph: g,
    graphId: id
  };
}

function geoObjToDrawingToolJson(geometry, width, height) {
  //'{"type":"rectangle","vertex":[{"x":500,"y":500},{"x":900,"y":900}]}',
  // console.log('sj objToDrwingToolJson', geometry)
  var arrow = false;

  var getVertex = function getVertex(geometry) {
    var type = geometry.$type;
    var item = geometry.point_list[0];
    var _vertex = [];

    switch (type) {
      case "rectangle":
      case "line":
      case "direction":
        if (item) {
          if (_.has(item, 'point_percentage')) {
            // percentage
            _vertex.push(getPixel(item.point_percentage[0]));

            _vertex.push(getPixel(item.point_percentage[1]));
          } else {
            // point
            _vertex = [{
              "x": Number(item.point[0].x[0]),
              "y": Number(item.point[0].y[0])
            }, {
              "x": Number(item.point[1].x[0]),
              "y": Number(item.point[1].y[0])
            }];
          }
        }

        break;

      case "polygon":
      case "polyline":
        if (item) {
          if (_.has(item, 'point_percentage')) {
            // percentage
            _vertex = item.point_percentage.map(function (it) {
              return getPixel(it);
            });
          } else {
            // point
            _vertex = item.point.map(function (it) {
              return {
                x: Number(it.x[0]),
                y: Number(it.y[0])
              };
            });
          }
        }

        break;

      default:
        break;
    }

    return _vertex;
  };

  var getPixel = function getPixel(percent) {
    var _x = Math.floor(Number(percent.x[0]) * width / 100);

    var _y = Math.floor(Number(percent.y[0]) * height / 100);

    return {
      x: _x,
      y: _y
    };
  };

  switch (geometry.$type) {
    case "rectangle":
      return JSON.stringify({
        type: "rectangle",
        // color: DEFAULT_COLOR,
        opacity: geometry.opacity,
        // vertex: [{ "x": Number(geometry.point_list[0].point[0].x[0]), "y": Number(geometry.point_list[0].point[0].y[0]) }, { "x": Number(geometry.point_list[0].point[1].x[0]), "y": Number(geometry.point_list[0].point[1].y[0]) }]
        vertex: getVertex(geometry)
      });
      break;

    case "line":
      if (geometry.$.arrow === "1") {
        arrow = true;
      }

      return JSON.stringify({
        type: "line",
        // color: DEFAULT_COLOR,
        opacity: geometry.opacity,
        // vertex: [
        //     { "x": Number(geometry.point_list[0].point[0].x[0]), "y": Number(geometry.point_list[0].point[0].y[0]) },
        //     { "x": Number(geometry.point_list[0].point[1].x[0]), "y": Number(geometry.point_list[0].point[1].y[0]) }
        // ],
        vertex: getVertex(geometry),
        arrow: arrow
      });
      break;

    case "direction":
      return JSON.stringify({
        type: "direction",
        // color: DEFAULT_COLOR,
        opacity: geometry.opacity,
        // vertex: [{ "x": Number(geometry.point_list[0].point[0].x[0]), "y": Number(geometry.point_list[0].point[0].y[0]) }, { "x": Number(geometry.point_list[0].point[1].x[0]), "y": Number(geometry.point_list[0].point[1].y[0]) }]
        vertex: getVertex(geometry)
      });
      break;

    case "polygon":
      // geometry.$ == undefiend in this case
      try {
        return JSON.stringify({
          type: "polygon",
          // color: DEFAULT_COLOR,
          opacity: geometry.opacity,
          tagName: geometry.tagName,
          // vertex: geometry.point_list[0].point.map((i) => {
          //     return { x: Number(i.x[0]), y: Number(i.y[0]) }
          // })
          vertex: getVertex(geometry)
        });
      } catch (error) {
        console.warn('parse polygon fail', geometry, error);
        return null; // if meet dirty data like:  polygon_list[0].polygon = [""]
        // show something that can be delete?
        // return JSON.stringify({
        //     type: "polygon",
        //     // color: DEFAULT_COLOR,
        //     opacity: geometry.opacity,
        //     vertex: [{x:0, y:0}, {x:0, y:10}, {x:10, y:0}, {x:10, y:10}],
        // })
      }

    case "polyline":
      var startPointColor = null;

      if (geometry.$.arrow === "1") {
        arrow = true;
      }

      if (geometry.$.start_point_color) {
        startPointColor = geometry.$.start_point_color;
      }

      return JSON.stringify({
        type: "polyline",
        // color: DEFAULT_COLOR,
        opacity: geometry.opacity,
        // vertex: geometry.point_list[0].point.map((i) => {
        //     return { x: Number(i.x[0]), y: Number(i.y[0]) }
        // }),
        vertex: getVertex(geometry),
        arrow: arrow,
        startPointColor: startPointColor
      });
      break;

    case "polyline_pair":
      {
        var getPolylineVertex = function getPolylineVertex(polyline) {
          // return polyline.point_list[0].point.map((i) => {
          //     return { x: Number(i.x[0]), y: Number(i.y[0]) }
          // })
          var _vertex = [];
          var item = polyline.point_list[0];

          if (item) {
            if (_.get(item, 'point_percentage')) {
              // percentage
              _vertex = item.point_percentage.map(function (it) {
                return _getPixel(it);
              });
            } else {
              // point
              _vertex = item.point.map(function (it) {
                return {
                  x: Number(it.x[0]),
                  y: Number(it.y[0])
                };
              });
            }
          }

          return _vertex;
        };

        var _getPixel = function _getPixel(percent) {
          var _x = Math.floor(Number(percent.x[0]) * width / 100);

          var _y = Math.floor(Number(percent.y[0]) * height / 100);

          return {
            x: _x,
            y: _y
          };
        };

        return JSON.stringify({
          type: "polyline_pair",
          // color: DEFAULT_COLOR,
          opacity: geometry.opacity,
          vertex: getPolylineVertex(geometry.polyline[0]),
          vertex2: getPolylineVertex(geometry.polyline[1]),
          // vertex2: geometry.polyline[1].point_list[0].point.map((i) => {
          //     return { x: Number(i.x[0]), y: Number(i.y[0]) }
          // }),
          names: ["From", "To", // geometry.$,index
          _.get(geometry, '$.serial_no')]
        });
        break;
      }

    default:
      console.warn("geoObjToDrawingToolJson receive unknown type ", geometry);
      return null;
      break;
  }
}

function addGraphic(json, _id) {
  var id = _id || v1();

  var obj = JSON.parse(json);
  var graphType = obj.type;

  _switchMode(graphType, id, {
    startPointColor: obj.startPointColor
  });

  importGraphic(json);
}

function reDraw(objects, width, height) {
  console.log('sj redraw', objects);
  removeAllGraphic();
  objects.map(function (obj) {
    var objJson = geoObjToDrawingToolJson(obj, width, height);

    if (objJson != null) {
      addGraphic(objJson, obj.id);
    }
  });
}

function createPolygonObjectsFromRoi(roiGeometry, opacity) {
  var geo = roiGeometry;

  if (geo.polygon_list && geo.polygon_list[0] && geo.polygon_list[0].polygon) {
    // console.log('sj ?', geo.polygon_list)
    var target = [];

    var key = _.get(geo, 'id');

    var tagName = _.get(geo, 'tagName', '');

    geo.polygon_list[0].polygon.map(function (item, index) {
      target.push(_objectSpread(_objectSpread({}, item), {}, {
        $type: "polygon",
        id: "".concat(key, "_oindex_").concat(index),
        opacity: opacity,
        tagName: tagName
      }));
    });
    return target;
  }

  return [];
}

function getMeta(url) {
  return new Promise(function (resolve, reject) {
    var img = new Image();

    img.onload = function () {
      return resolve(img);
    };

    img.onerror = reject;
    img.src = url;
  });
}

window.getM = getMode;
window.gm = getGraphicsManager();
export { drawingToolApp, getMeta };
export default DrawingToolView;